import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../utils/analytics'
import { fbTrackPageView } from '../utils/facebookPixel'

/**
 * Hook to automatically track page views on route changes
 * Use this in a component inside the Router
 */
export const usePageTracking = () => {
  const location = useLocation()

  useEffect(() => {
    // Track page view on route change (GA4)
    trackPageView(location.pathname + location.search)
    // Track page view on route change (FB Pixel)
    fbTrackPageView()
  }, [location])
}

/**
 * Component wrapper for page tracking - use in route tree
 */
export const PageTracker = () => {
  usePageTracking()
  return null
}

export default usePageTracking
